import React, { useRef, useState } from 'react';

import { Form, message } from 'antd';
import './Uploader.scss';
import { useTranslation } from 'react-i18next';
import { ALLOWED_FILE_ACCEPT, ALLOWED_FILE_TYPES } from '../helpers/constants';

const Uploader = ({ props }) => {
  const { names, handleFileUploaded, currentFile, docTypeCode } = props;
  const [selectedFile, setSelectedFile] = useState(currentFile);
  const inputRef = useRef(null);

  const { t } = useTranslation();
  const onFileUpload = (e) => {
    const file = e.target.files[0];
    if (file && !ALLOWED_FILE_TYPES.includes(file.type)) {
      message.error({
        content: t('errors.invalidFileType'),
        duration: 2.5,
        className: 'card-message',
      });
      if (inputRef.current) {
        inputRef.current.value = '';
      }
      return;
    }
    setSelectedFile(file);
    handleFileUploaded(file);
  };

  return (
    <Form.Item name={names}>
      <div className="row" style={{ display: 'grid', placeItems: 'center' }}>
        <label
          htmlFor={docTypeCode}
          style={{
            background: '#dedcdc',
            padding: '5px 20px',
          }}
        >
          {t(`actions.chooseFile`)}
        </label>
        {selectedFile && (
          <div
            style={{
              overflow: 'hidden',
              textOverflow: 'ellipsis',
              whiteSpace: 'normal',
              wordWrap: 'break-word',
              wordBreak: 'break-all',
            }}
          >
            {selectedFile.name}
          </div>
        )}
      </div>
      <input
        ref={inputRef}
        id={docTypeCode}
        className="input_container"
        type="file"
        accept={ALLOWED_FILE_ACCEPT}
        style={{ display: 'none' }}
        onChange={(e) => onFileUpload(e)}
      />
    </Form.Item>
  );
};

export default Uploader;
